import { JsonObject } from '../../app/json/jsonValue.js';
import { SlotPlaceholder } from './slotPlaceholder.js';
import type { PreprocessedTemplate } from './preprocessedTemplate.js';

export class TemplatePlaceholder {
    name: string = '';
    startIndex: number = 0;
    endIndex: number = 0;
    fullMatch: string = '';
    templateKey: string = '';
    nestedPlaceholders: TemplatePlaceholder[] = [];
    nestedSlots: SlotPlaceholder[] = [];
    resolvedTemplate: PreprocessedTemplate | null = null;
    resolvedJson: JsonObject | null = null;
    resolvedAppSite: string | null = null;
    resolvedTemplateName: string | null = null;

    constructor() {}

}
